export default __webpack_public_path__ + "static/press-enquiries-263f8dcc742d85ad844a197a77177d9e.webp";